import api from "Helpers/Api";
import { JobsRequestList, TJob } from "Services/Job/job";
import { IPagination } from "Services/pagination";

export default async function jobsList({
  page,
  perPage,
  segment,
  search,
  states,
  cities,
  salary,
  section,
  userId,
}: JobsRequestList) {
  const { data } = await api.get<IPagination<TJob>>("/jobs/", {
    params: {
      userId: userId && userId,
      search: search,
      category: section && section.category,
      tags: section && section.tags,
      page: page,
      perPage: perPage,
      undefinedSalaries: true,
      published: true,
      states,
      cities,
      salary,
      segment: segment,
    },
  });

  return data;
}
